import React, { useEffect } from 'react';
import LockLockedIcon from '@atlaskit/icon/core/lock-locked';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import { useAnalyticsEvents, fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';

import { AlikeSmartLink } from '../alike-smart-link/index.tsx';
import messages from './messages.tsx';

export const RestrictedIcon = (): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<LockLockedIcon
			label={formatMessage(messages.restrictedProject)}
			size="small"
			color={token('color.icon.danger')}
		/>
	);
};

export const RestrictedAlikeSmartLink = (): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	useEffect(() => {
		fireTrackAnalytics(createAnalyticsEvent({}), 'atlasProjectRestrictedAlikeSmartLink viewed');
	}, [createAnalyticsEvent]);

	return (
		<AlikeSmartLink icon={<RestrictedIcon />} content={formatMessage(messages.restrictedProject)} />
	);
};
